
import React, { RefObject } from 'react';

interface LegalSectionProps {
  id: string;
  title: string;
  children: React.ReactNode;
  titleRef?: RefObject<HTMLHeadingElement>;
}

const LegalSection: React.FC<LegalSectionProps> = ({ id, title, children, titleRef }) => {
  return (
    <section 
      id={id} 
      className="mb-6 md:mb-10"
      aria-labelledby={`section-heading-${id}`}
    >
      <h2 
        id={`section-heading-${id}`}
        ref={titleRef} 
        className="text-xl md:text-2xl font-future tracking-wide font-semibold mb-3 md:mb-4 text-purple-200 pb-2 border-b border-purple-500/30 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-500 focus-visible:ring-offset-2 focus-visible:ring-offset-black rounded"
        tabIndex={0}
      >
        {title}
      </h2>
      <div className="prose prose-invert max-w-none prose-headings:text-purple-100 prose-p:text-gray-300 text-gray-300">
        {children}
      </div>
    </section>
  );
};

export default LegalSection;
